// Adapted from https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g

export interface RequestInitRetry extends RequestInit {
  retries: number;
}

const retryFetch = async (
  input: RequestInfo,
  init: RequestInitRetry
): Promise<Response> => {
  const { retries, ...initFetch } = init;
  try {
    return await fetch(input, initFetch);
  } catch (error) {
    if (retries === 1) {
      throw error;
    }
    return await retryFetch(input, { retries: retries - 1, ...initFetch });
  }
};

export default retryFetch;
